<template>
    <Input
        :value="valueComputed"
        :placeholder="placeholder"
        :disabled="disabled"
        @update:value="onUpdateValue"
        @focus="() => (data.focus = true)"
        @blur="onBlur"
    ></Input>
</template>

<script>
import { Input } from "ant-design-vue";
import { computed, defineComponent, reactive } from "vue";
import { createOnBlur, formatInputValue, onUpdateValue } from "./input-number.logic";

export default defineComponent({
    components: {
        Input
    },
    props: {
        value: {},
        placeholder: {},
        maxDecimal: { default: 13 },
        allowMinus: { default: false },
        allowPrecision: { default: false },
        maxPrecision: { default: 2 },
        comma: { default: true },
        disabled: {},
        autoPrecision: { default: true },
        allowLeadZero: { default: true }
    },
    emits: ["update:value", "blur"],
    setup(props, { emit }) {
        const data = reactive({ focus: false });
        const valueComputed = computed(() => formatInputValue({ props, data }));
        return {
            data,
            valueComputed,
            onUpdateValue: onUpdateValue({ props, emit }),
            onBlur: createOnBlur({ data, emit })
        };
    }
});
</script>
